import { useContext } from 'react';
import { MainContext } from 'components/layout/MainContext';

export const useIsSessionOpen = (): boolean => {
    const { session } = useContext(MainContext);

    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    return session !== null && session.token !== null;
};
